import { useEffect, useState } from "react";
import "../../../../assets/css/loa1.scss";
import Logo from "../../../../assets/img/logo_1.png";

const MeritDataList_RF_V1 = ({ category, InputValues, setShowModal }) => {

    const categoryNames = {
        1: "Not using your overdraft for just a short-term emergency",
        2: "Could not clear the overdraft in a reasonable period of time.",
        3: "Not maintained a positive balance for a significant period of time",
    };
  return (
    <>
      <div
        className={`modal blackover fade ${category ? "show" : "hide"}`}
        id="sample"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className={`modal-content  goodnews_popup `}>
            <div className="modal-body">
              <div className={`pb-3 text-center px-lg-4 px-md-4  px-sm-01  `}>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn-close close22"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowModal(0)}
                  ></button>
                </div>
                <div className="d-flex justify-content-start">
                  <div className="">
                    <div className="body-class container">
                      <section className="body_all">
                        <div className="page-break" />
                        <table className="adition_page3">
                          <tbody style={{ display: "table" }}>
                            <tr>
                              <td style={{ width: "100%" }}>
                                <center>
                                  <img
                                    src={Logo}
                                    style={{ height: "60px" }}
                                    alt="Logo"
                                  />
                                </center>
                                <h2 className="questh2 mt-2">
                                  {categoryNames[category]}
                                </h2>
                                <br />
                                <div className="text-start">
                                  <div>
                                    <ol>
                                      <li>
                                        Did you use your overdraft for the
                                        occasional unforeseen emergency or was
                                        it used regularly for day-to-day
                                        expenditure?
                                      </li>
                                      <li>
                                        While having an overdraft did any of the
                                        following apply:
                                      </li>
                                      <li>
                                        Did you take out further borrowing so
                                        that you could manage your finances?
                                      </li>
                                      <li>
                                        Please select the type of borrowing you
                                        took:
                                      </li>
                                      <li>
                                        Did you struggle to meet your essential
                                        repayments while being in your
                                        overdraft?
                                      </li>
                                      <li>
                                        You’ve told us you were stuck in your
                                        overdraft, as a result you didn’t see a
                                        frequent positive balance – how did this
                                        affect you?
                                      </li>
                                    </ol>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeritDataList_RF_V1;
